import { TmApiError } from '@/core/error/transport/tmApiError'
import type { InternalErrorResponseBase, TmAxiosResponse } from '@/services/transport/types'
import type { TmTransportHttpErrorCode } from '@/core/error/transport/types'

export class TmApiServerError<T extends TmAxiosResponse<InternalErrorResponseBase>> extends TmApiError<T> {
  public name = 'TmApiCriticalError'

  protected override code: TmTransportHttpErrorCode = 500
}
